import {useClient, useLocation} from '@adamlip/okeoke.client';
import {createContext, useEffect, useState} from 'react';
import merge from 'lodash.merge';
import cloneDeep from 'clone-deep';
import {setProps} from 'utils/SetProps';
import {Helpers} from 'utils/Helpers-v1';
import {useNavigate} from 'react-router-dom';
import {isDesktop} from 'react-device-detect';

const AppParamsContext = createContext();

const AppParamsContextProvider = ({children}) => {
	const {appParams, brandID} = useClient();
	const {location} = useLocation();
	const navigate = useNavigate();

	const [localAppParams, setLocalAppParams] = useState({});
	const [appParamsLoaded, setAppParamsLoaded] = useState(false);
	const [desktopView, setDesktopView] = useState(false);
	useEffect(() => {
		if (location != null && appParams != null) {
			if (location?.attributes?.locationParams?.brandApp != null && appParams?.general?.appParamsByLocations === true) {
				let params = cloneDeep(appParams);
				let newValues = merge(params, location?.attributes?.locationParams?.brandApp);
				setLocalAppParams({...newValues});
			} else {
				setLocalAppParams(appParams);
			}
			if (isDesktop) {
				setDesktopView(true);
			} else {
				setDesktopView(false);
			}
		}
	}, [location, appParams]);
	useEffect(() => {
		const handleMessage = (event) => {
			if (event.data?.type === 'update') {
				setLocalAppParams(event.data.data);
			} else if (event?.data?.type === 'changePreviewType') {
				setDesktopView(event.data.data === 'mobile' ? false : true);
			}
		};

		window.addEventListener('message', handleMessage);

		return () => {
			window.removeEventListener('message', handleMessage);
		};
	}, []);
	useEffect(() => {
		if (localAppParams != null) {
			if (localAppParams?.navigation?.defaultUrl != null && localAppParams?.navigation?.defaultUrl !== '' && location.pathname === '/') {
				navigate(localAppParams?.navigation?.defaultUrl);
			}
			setProps(localAppParams);
			Helpers.sendMessageToWebView(JSON.stringify({action: 'appParams', data: localAppParams}));
			//Mozata font
			if (brandID === 'pbz9fdc3') {
				document.documentElement?.style.setProperty('--body-font', 'Gotham');
			}
			setAppParamsLoaded(true);
		}
		//eslint-disable-next-line
	}, [localAppParams]);

	return <AppParamsContext.Provider value={{appParams: localAppParams, appParamsLoaded, desktopView: process.env.NODE_ENV === 'development' ? false : desktopView, setDesktopView}}>{Object.keys(localAppParams).length !== 0 && children}</AppParamsContext.Provider>;
};

export {AppParamsContext, AppParamsContextProvider};
